<template>
    <div>
        <div class="input-group input-group-sm">
            <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca Attività..." :tabindex="1" v-model="search.TITOLO.VALUE"/>
            <button class="btn btn-light" type="button" @click="allExpanded = !allExpanded" title="Espandi/Chiudi tutte">
                <i :class="allExpanded ? 'ph-caret-down' : 'ph-caret-right'"></i>
            </button>
        </div>
        <div class="card">
            <div class="card-body">
                <div v-if="paginatedList.arr && paginatedList.arr.length > 0">
                    <div v-for="attivita in paginatedList.arr" :key="attivita.ID_ATTIVITA" class="mb-3">
                        <TabAttvitaSchedaVisualizzazioneProgetto :attivita="attivita" :filters="filters" :tipo="tipo" :force-expanded="allExpanded" />
                    </div>
                </div>
                <div v-else class="text-muted p-2">Nessuna attività disponibile</div>
            </div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-2 riga-pagine">
            <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
            <select class="form-select form-select-sm w-auto" v-model="search.PAGINATION.PAGE_SIZE" @change="search.PAGINATION.PAGE_NUMBER = 1">
                <option v-for="n in [5, 10, 25, 50, 75, 100, 250, 500]" :key="n" :value="n">{{ n }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import TabAttvitaSchedaVisualizzazioneProgetto from '@/components/utils/TabAttvitaSchedaVisualizzazioneProgetto.vue'

export default {
    name: "TabAlberoAttivitaProgetto",
    components: { Pagine, TabAttvitaSchedaVisualizzazioneProgetto },
    props: {
        attivita: { type: Array, default: () => [] },
        tipo: { type: String, default: 'vendita' }
    },
    data() {
        return {
            filters: global.filters,
            allExpanded: null,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
                TITOLO: { TYPE: 'TEXT', VALUE: '' },
            },
        }
    },
    computed: {
        paginatedList() {
            return utils.inGrid(this.attivita, this.search);
        }
    }
}
</script>

<style scoped>
.riga-pagine :deep(nav), .riga-pagine :deep(.pagination) { margin: 0; }
</style>
